module.exports = __webpack_public_path__ + "static/media/checkbox_tick.287ab687.svg";